import React from 'react';

class Scale extends React.Component {
    render() {
        return (
            <section className="stat"><h2 className="stat__title">Масштаб</h2>
                <div className="stat__stat-list">
                    <div className="stat__stat-item"><p className="stat__number">27 499</p><p
                        className="stat__desc">проектов</p></div>
                    <div className="stat__stat-item"><p className="stat__number">24 718</p><p
                        className="stat__desc">анкет</p></div>
                    <div className="stat__stat-item"><p className="stat__number">1 228 500</p><p
                        className="stat__desc">вопросов</p></div>
                    <div className="stat__stat-item"><p className="stat__number">482 955 188</p><p
                        className="stat__desc">интервью</p></div>
                    <div className="stat__stat-item"><p className="stat__number">2 584 247 170</p><p
                        className="stat__desc">ответов</p></div>
                    <div className="stat__stat-item"><p className="stat__number">2 028</p><p
                        className="stat__desc">клиентов</p></div>
                </div>
                <p className="stat__info">За время существования, в системе было проведено более 27 499 проектов по более
                    чем 24 718 анкетам, содержащим более 1 228 500 вопросов.</p>
                <p className="stat__info">Всего было собрано
                    более 482 955 188 интервью, и сохранено более 2 584 247 170 ответов.</p>
                <p className="stat__info">На
                    текущий момент на сайте зарегистрировано более 2 028 клиентов.</p>
            </section>
        )
    }
}

export default Scale;


// WEBPACK FOOTER //
// ./src/Components/SurveyStudio/Scale.js